import "./WhatWeDo.css";

const WhatWeDo = () => {
  return (
    <section className="whatwedo-section">
      <div className="whatwedo-container">
        <h2>What We Do</h2>

        <p className="whatwedo-intro">
          We are a purpose-driven company engaged in the trading and sourcing of
          premium Indian agricultural products, including dry fruits, spices,
          moringa-infused products, and authentic GI (Geographical Indication)
          goods.
        </p>

        <p>
          Our core strength lies in direct partnerships with farmers, allowing us
          to source products straight from the fields. This approach eliminates
          unnecessary intermediaries, ensures fair pricing, and delivers superior
          quality to global customers.
        </p>

        <p>
          By promoting India’s rich agricultural heritage and connecting farmers
          directly to international markets, we support sustainable trade,
          transparency, and long-term relationships built on trust and shared
          growth.
        </p>
      </div>
    </section>
  );
};

export default WhatWeDo;
